export default (set, get, data) => set(
  () => ({
    configurator: {
      ...get().configurator,
      ...data
    }
  }),
  false,
  { type: 'configurator/updateConfigurator', data }
);
